"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AugustPools = void 0;
const utils_1 = require("@augustdigital/utils");
const getters_1 = require("./getters");
const ethers_1 = require("ethers");
const user_actions_1 = require("./user-actions");
class AugustPools extends utils_1.AugustBase {
    constructor(baseConfig) {
        super(baseConfig);
    }
    getPools() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.authorized)
                throw new Error('Not authorized.');
            return yield (0, getters_1.getLendingPools)({
                rpcUrl: this.activeNetwork.rpcUrl,
                optionalFields: { loans: true },
            });
        });
    }
    getPool(pool) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.authorized)
                throw new Error('Not authorized.');
            if (!pool)
                throw new Error('Pool input parameter is undefined.');
            if (!(0, ethers_1.isAddress)(pool))
                throw new Error(`Pool input parameter is not an address: ${String(pool)}`);
            return yield (0, getters_1.getLendingPool)({
                pool,
                rpcUrl: this.activeNetwork.rpcUrl,
                optionalFields: { loans: true },
            });
        });
    }
    getPoolApr(pool, optionalParams) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.authorized)
                throw new Error('Not authorized.');
            if (!pool)
                throw new Error('Pool input parameter is undefined.');
            if (!(0, ethers_1.isAddress)(pool))
                throw new Error(`Pool input parameter is not an address: ${String(pool)}`);
            return yield (0, getters_1.getLendingPoolApr)({
                pool,
                rpcUrl: this.activeNetwork.rpcUrl,
                inputParams: optionalParams,
            });
        });
    }
    getPoolTvl(pool, optionalParams) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.authorized)
                throw new Error('Not authorized.');
            if (!pool)
                throw new Error('Pool input parameter is undefined.');
            if (!(0, ethers_1.isAddress)(pool))
                throw new Error(`Pool input parameter is not an address: ${String(pool)}`);
            return yield (0, getters_1.getLendingPoolTvl)({
                pool,
                rpcUrl: this.activeNetwork.rpcUrl,
                inputParams: optionalParams,
            });
        });
    }
    getAvailableRedemptions(pool, address) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.authorized)
                throw new Error('Not authorized.');
            if (!pool)
                throw new Error('Pool input parameter is undefined.');
            if (!(0, ethers_1.isAddress)(pool))
                throw new Error(`Pool input parameter is not an address: ${String(pool)}`);
            return yield (0, getters_1.getLendingPoolAvailableRedemptions)({
                pool,
                rpcUrl: this.activeNetwork.rpcUrl,
                address,
            });
        });
    }
    allowance(pool, signer) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = (yield signer.getAddress());
            return yield (0, user_actions_1.allowance)(signer, { pool, wallet, wait: true });
        });
    }
    approve(pool, signer, inputParams) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = (yield signer.getAddress());
            return yield (0, user_actions_1.approve)(signer, {
                pool,
                wallet,
                wait: true,
                amount: inputParams.amount,
            });
        });
    }
    deposit(pool, signer, inputParams) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = (yield signer.getAddress());
            return yield (0, user_actions_1.deposit)(signer, {
                amount: inputParams.amount,
                wallet,
                pool: pool,
                wait: true,
            });
        });
    }
    requestWithdrawal(pool, signer) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = (yield signer.getAddress());
            return yield (0, user_actions_1.requestRedeem)(signer, { pool, wallet, wait: true });
        });
    }
    withdraw(pool, signer, inputParams) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = (yield signer.getAddress());
            return yield (0, user_actions_1.redeem)(signer, Object.assign(Object.assign({ wallet, pool }, inputParams), { wait: true }));
        });
    }
}
exports.AugustPools = AugustPools;
//# sourceMappingURL=main.js.map